import mainLogo from '../../images/Recreio/recreioBH_logo_main_color.png';
import squareLogo from '../../images/Recreio/recreioBH_logo_square_color.png';
import bannerLogoWhite from '../../images/Recreio/recreioBH_logo_main_white.png';
import banner01 from '../../images/Recreio/recreiobg_banner_01.webp';
import banner02 from '../../images/Recreio/recreiobg_banner_02.webp';
import banner03 from '../../images/Recreio/recreiobg_banner_03.webp';
import banner04 from '../../images/Recreio/recreiobg_banner_04.webp';
import car123 from '../../images/Recreio/123_nivus.jpg';
import box123 from '../../images/Recreio/123_vw.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Recreio',
    defaultStoreLink: 'pecasbh.recreiovw.com.br',
    defaultContactEmail: 'vendasonline.recreiobh@grupolider.com.br',
    whatsappNumber: '31 3319 9053',
    CNPJname: 'RECREIO B. H. VEICULOS S.A.',
    CNPJ: '01.929.665/0001-47',
    CNPJaddress: 'AV BARAO HOMEM DE MELO, 3535 - Estoril, Belo Horizonte - MG, 30.494-275',
    launchDate: '18/02/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "RECREIO BH VW",
        // "RECREIO RJ VW",
        // "RECREIO VW MG - MILA",
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
    ],

    urlRedirect: {
        // '/_Discount_5-100_NoIndex_True': '',
        // // '/_Discount_5-100_NoIndex_True#applied_filter_id%253Ddiscount%2526applied_filter_name%253DDes': '',
        // '/lista/acessorios-veiculos/': '/categorias',
        // '/lista/acessorios-veiculos/pecas-carros-caminhonetes/': '/categorias',
        // '/lista/acessorios-veiculos/rodas/': '/categorias',
        // '/lista/acessorios-veiculos/pneus/pneus-carros-caminhonetes/': '/categorias',
        // '/lista/calcados-roupas-bolsas/': '/produtos/vestuario',
        // '/lista/acessorios-veiculos/pecas-carros-caminhonetes/motor/': '/categorias',
        // '/lista/acessorios-veiculos/pecas-carros-caminhonetes/pecas-interior/': '/categorias',
        // '/lista/acessorios-veiculos/carros-caminhonetes/interior/tapetes/': '/categorias',
        // '/lista/acessorios-veiculos/pecas-carros-caminhonetes/suspensao-direcao/amortecedores/': '/categorias',
        // '/lista/acessorios-veiculos/pecas-carros-caminhonetes/freios/': '/categorias',
        // '/lista/acessorios-veiculos/pecas-carros-caminhonetes/filtros/': '/categorias',
        // '/lista/acessorios-veiculos/pecas-carros-caminhonetes/transmissao/transmissao/': '/categorias',
        // '/lista/acessorios-veiculos/pecas-carros-caminhonetes/ignicao/': '/categorias',
        // '/lista/acessorios-veiculos/lubrificantes-fluidos/carros-caminhonetes/': '/categorias',
        // '/lista/acessorios-veiculos/pecas-carros-caminhonetes/carroceria/': '/categorias',
        // '/lista/acessorios-veiculos/pecas-carros-caminhonetes/suspensao-direcao/suspensao-direcao/': '/categorias',
        // '/lista/acessorios-veiculos/pecas-carros-caminhonetes/iluminacao/': '/categorias',
        // '/lista/acessorios-veiculos/pecas-carros-caminhonetes/climatizacao/': '/categorias',
        // '/lista/acessorios-veiculos/tuning/merchandising/': '/produtos/vestuario',

        '/_Discount_5-100_NoIndex_True': '',
        // '/_Discount_5-100_NoIndex_True#applied_filter_id%253Ddiscount%2526applied_filter_name%253DDes': '',
        '/lista/acessorios-veiculos/': '/produtos/Acessórios',
        '/lista/acessorios-veiculos/pecas-carros-caminhonetes/': '/produtos/Acessórios',
        '/lista/acessorios-veiculos/rodas/': '/produtos/Acessórios',
        '/lista/acessorios-veiculos/pneus/pneus-carros-caminhonetes/': '/produtos/Acessórios',
        '/lista/calcados-roupas-bolsas/': '/produtos/vestuario',
        '/lista/acessorios-veiculos/pecas-carros-caminhonetes/motor/': '/produtos/Motor%20&%20Periféricos',
        '/lista/acessorios-veiculos/pecas-carros-caminhonetes/pecas-interior/': '/categorias',
        '/lista/acessorios-veiculos/carros-caminhonetes/interior/tapetes/': '/produtos/Acessórios',
        '/lista/acessorios-veiculos/pecas-carros-caminhonetes/suspensao-direcao/amortecedores/': '/produtos/Suspensão%20&%20Direção',
        '/lista/acessorios-veiculos/pecas-carros-caminhonetes/freios/': '/produtos/Freios',
        '/lista/acessorios-veiculos/pecas-carros-caminhonetes/filtros/': '/produtos/Filtros',
        '/lista/acessorios-veiculos/pecas-carros-caminhonetes/transmissao/transmissao/': '/produtos/Transmissão%20&%20Embreagens',
        '/lista/acessorios-veiculos/pecas-carros-caminhonetes/ignicao/': '/produtos/Ignição%20&%20Elétrica',
        '/lista/acessorios-veiculos/lubrificantes-fluidos/carros-caminhonetes/': '/produtos/Lubrificantes%20e%20Fluidos',
        '/lista/acessorios-veiculos/pecas-carros-caminhonetes/carroceria/': '/produtos/Carroceria',
        '/lista/acessorios-veiculos/pecas-carros-caminhonetes/suspensao-direcao/suspensao-direcao/': '/produtos/Suspensão%20&%20Direção',
        '/lista/acessorios-veiculos/pecas-carros-caminhonetes/iluminacao/': '/produtos/Iluminação',
        '/lista/acessorios-veiculos/pecas-carros-caminhonetes/climatizacao/': '/categorias',
        '/lista/acessorios-veiculos/tuning/merchandising/': '/produtos/vestuario',

        '/p/blog-1': '',

        
    }
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: banner04,
    bannerBrands: '',
    aboutUsBg: banner04,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais <span style="font-weight: bold;">Volkswagen</span> direto da concessionária <span style="font-weight: bold;">Recreio BH</span>.',
    aboutUs: {
        title: 'Sobre nós',
        content: [
            'A Recreio BH foi inaugurada em 1998 como a maior concessionária Volkswagen do mundo. E até hoje, com seus 36.000 m² de área construída, figura entre as maiores.',
            'Seu moderno projeto arquitetônico, com espaços para negócios e lazer, prioriza o conforto e bem estar dos seus clientes e colaboradores.',
            'A Recreio BH é pioneira na execução de ações de marketing cultural com a criação do Espaço Cultural Recreio, que conta com Galeria de Arte, Boulevard com lanchonete e área para realização de espetáculos infantis e shows.',
            'Oferecendo sempre os melhores negócios em Volkswagen em BH, a empresa se consolidou como líder em vendas de veículos, peças e serviços em Minas Gerais.',
            'A Recreio BH é uma empresa do Grupo Lider. Presente nos estados de MG, RJ e ES, o Grupo originário de Muriaé, MG, tem quase 60 anos de história e é o maior Grupo de concessionárias do país.'
        ],
        link: 'https://www.recreiovw.com.br/belo-horizonte',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/recreio.vw/',
        Facebook: 'https://www.facebook.com/recreiovw',
        LinkedIn: 'https://br.linkedin.com/company/recreiobh',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}